import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAttrs } from 'vue'
import { useRouter } from 'vue-router'
import { Icon } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { emit }) {


const router = useRouter()
const attrs = useAttrs()

// 返回按钮事件
const goback = () => {
    if (attrs.onBack) {
        emit('back')
    } else {
        router.go(-1)
    }
}

return (_ctx: any,_cache: any) => {
  const _component_app_statusbar = _resolveComponent("app-statusbar")!

  return (_openBlock(), _createBlock(_component_app_statusbar, {
    class: "app-navback",
    onClick: goback
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_unref(Icon), { name: "arrow-left" })
      ])
    ]),
    _: 3
  }))
}
}

})